// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"336":"468c50dd","459":"5bf428c7","881":"3f2250b7"}[chunkId] + ".chunk.js";
};